/** Keep text search identical in controls, API payloads and saved URLs. */
export function normalizeSearchText(value) {
  const scalar = Array.isArray(value) ? value[0] : value;
  return String(scalar ?? '').trim().replace(/\s+/gu, ' ');
}

/** Every word may match a different field; punctuation is always literal. */
export function matchesSearchText(values, query) {
  const text = normalizeSearchText(query).toLowerCase();
  if (!text) return true;
  const fields = values.map((value) => String(value ?? '').toLowerCase());
  return text.split(' ').every((token) => fields.some((field) => field.includes(token)));
}
